import * as React from 'react'
import { WorkspaceSubscriptionMainConnected } from './WorkspaceSubscriptionMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const WorkspaceSubscriptionMainExamples = () => {
  return (
    <div className="WorkspaceSubscriptionMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <WorkspaceSubscriptionMainConnected />
      </Provider>
    </div>
  )
}
